import React, { useEffect } from 'react';
import '../styles/Features.css';
import servicesData from '../data/servicesData';

const Features = () => {
  const getImagePath = (fileName) => `/images/${encodeURIComponent(fileName)}`;

  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 20;

    const scrollToTargetCard = () => {
      const pendingSlug = sessionStorage.getItem('scrollToServiceCard');
      const hashTarget = window.location.hash ? window.location.hash.replace('#', '') : null;

      const targetId = pendingSlug
        ? `service-card-${pendingSlug}`
        : hashTarget && hashTarget.startsWith('service-card-')
          ? hashTarget
          : null;

      if (!targetId) {
        return;
      }

      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        sessionStorage.removeItem('scrollToServiceCard');
        return;
      }

      attempts += 1;
      if (attempts < maxAttempts) {
        setTimeout(scrollToTargetCard, 100);
      }
    };

    setTimeout(scrollToTargetCard, 100);
  }, []);

  return (
    <section id="services" className="features">
      <div className="features-container">
        <h2 className="section-title">Our Services</h2>
        <div className="features-grid">
          {servicesData.map(feature => (
            <div
              key={feature.id}
              id={`service-card-${feature.slug}`}
              className="feature-card"
            >
              <img
                src={getImagePath(feature.image)}
                alt={feature.title}
                className="feature-image"
                loading="lazy"
                onError={(event) => {
                  event.currentTarget.src = '/images/airport.jpg';
                }}
              />
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.summary}</p>
              <a href={`/services/${feature.slug}`} className="feature-btn">{feature.title}</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
